export const useStyles = (theme) => ({
    styledMenuContainer: {
        display: 'flex',
        alignItems: 'center',
        '& svg': {
            color: '#fff',
        },
    },
    button: {
        '& span': {
            textTransform: 'none',
        },
        '&:hover': {
            color: '#0088ff !important',
        },
        color: '#fff !important',
    },
    menuItem: {
        fontFamily: theme?.typography?.primary?.main || '#fff',
    },
});
